{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.DataGrid.Options;

{$IFDEF PAS2JS}
  // The FAKEINTERFACE is used to optimize the generated JavaScript
  // while retaining the benefit of type checking by the the
  // Delphi / RAD Studio IDE and Pas2JS when needed.
  {$DEFINE FAKEINTERFACE}
{$ENDIF}
{$IFDEF PAS2JS}{$MODE DELPHI}{$ENDIF}

interface
uses
  WEBLib.DataGrid.Common,
  Classes, web, JS, WEBLib.Controls, WEBLib.Graphics, SysUtils,
  WEBLib.StdCtrls, WebLib.Menus,
  jsdelphisystem, WEBLib.DataGrid.CellComponents,
{$IFDEF PAS2JS}
  WEBLib.RegularExpressions,
{$ELSE}
  System.RegularExpressions,
{$ENDIF}
  libdatagrid, Types, lib.propertyserializer, WEBLib.DataGrid.libjs;


type
{$REGION 'Header Test'}
//AC:  TDGParentHeaderType = String;
{$ENDREGION}
{$REGION 'Events Declarations'}
  TDataGridChangedEvent = procedure(Sender: TObject) of object;
  TDGColumnValueGetter = function(Params: TJSValueGetterParam): string of object;
  TDGColumnValueFormatter = function(Value: string): string of object;
  TDGCustomCellRender = function(Params: TJSCellRendererParam): TJSValue of object;
  TDGCellClassFunc = function(Params: TJSCellClassParams): TJSValue of object;
  TDGCellStyleFunc = function(Params: TJSCellClassParams): TJSValue of object;
{$ENDREGION}
{$REGION 'Interface Declarations'}
  ISGChange = {$IFNDEF FAKEINTERFACE}interface{$ELSE}class{$ENDIF}
    procedure ApplyChanges; {$IFDEF FAKEINTERFACE}virtual; abstract;{$ENDIF}
    procedure RegisterCallback(Callback: TDataGridChangedEvent); {$IFDEF FAKEINTERFACE}virtual; abstract;{$ENDIF}
  end;
{$ENDREGION}

{$REGION 'Base Classes'}
  TDGCollectionItem = class(TCollectionItem)
  end;
  TDGCollection = class(TOwnedCollection{$IFNDEF FAKEINTERFACE}, ISGChange{$ENDIF})
  protected
    FCallback: TDataGridChangedEvent;
    FInChangeTransaction: Boolean;

    procedure DoChange; virtual;
  public
    procedure BeginChanges;
    procedure ApplyChanges;
    procedure RegisterCallback(Callback: TDataGridChangedEvent);
{$IFNDEF FAKEINTERFACE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
    function _AddRef: Integer; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
{$ENDIF}
  end;

  TDGPersistent = class(TPersistent{$IFNDEF FAKEINTERFACE}, ISGChange{$ENDIF})
  protected
    FCallback: TDataGridChangedEvent;
    FInChangeTransaction: Boolean;

    procedure DoChange; virtual;
  public
    procedure BeginChanges;
    procedure ApplyChanges;
    procedure RegisterCallback(Callback: TDataGridChangedEvent);
{$IFNDEF FAKEINTERFACE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
    function _AddRef: Integer; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
    function _Release: Integer; {$IFNDEF PAS2JS}stdcall;{$ENDIF}
{$ENDIF}
  end;
{$ENDREGION}



{$REGION 'Cell Editor Params'}
  TDGSelectCellEditorCollectionItem = class(TCollectionItem)
  private
    FText: string;
    FValue: String;
  protected
    function GetDisplayName: string; override;
  public
    procedure Assign(Source: TPersistent); override;
  published
    property Text: string read FText write FText;
    property Value: String read FValue write FValue;
  end;

  TDGSelectCellEditorCollection = class(TOwnedCollection)
  private
    FOnChange: TNotifyEvent;
    function GetItem(Index: integer): TDGSelectCellEditorCollectionItem; reintroduce;
    procedure SetItem(Index: integer; const Value: TDGSelectCellEditorCollectionItem); reintroduce;
  protected
    procedure DoChange; virtual;
    procedure Update(Item: TCollectionItem); override;
  public
    constructor Create(AOwner: TPersistent); reintroduce; overload;
    constructor Create(AOwner: TPersistent; ItemClass: TCollectionItemClass); overload;
    function Add: TDGSelectCellEditorCollectionItem; reintroduce;
    function Insert(Index: integer): TDGSelectCellEditorCollectionItem; reintroduce;
    property Items[Index: integer]: TDGSelectCellEditorCollectionItem read GetItem write SetItem; default;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  end;

{$ENDREGION}



{$REGION 'TDGMultilevelHeaderCollection'}
  TDGMultilevelHeaderCollection = class;
  TDGMultilevelHeaderCollectionItem = class;
  TDGMultilevelHeaderParams = record
    Item: TDGMultilevelHeaderCollectionItem;
    Level: Integer;
    PathName: String;
  end;
  TDGMultilevelHeaderCollectionItem = class(TDGCollectionItem)
  private
    FHeaders: TDGMultilevelHeaderCollection;
    FName: String;
    FParent: TDGMultilevelHeaderCollection;
    FOnChange: TNotifyEvent;
    FInternalParentObject: TJSObject;

    procedure SetHeaders(const Value: TDGMultilevelHeaderCollection);
    function GetPathName: String;
    procedure SetName(const Value: String);
  protected
    function GetDisplayName: string; override;

    procedure DoChange;

  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;

    property Parent: TDGMultilevelHeaderCollection read FParent;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;

    property InternalJSObject: TJSObject read FInternalParentObject write FInternalParentObject;
  published
    property HeaderName: String read FName write SetName;
    property Headers: TDGMultilevelHeaderCollection read FHeaders write SetHeaders;
  end;

  TDGMultilevelHeaderCollection = class(TDGCollection)
  private
    FParentItem: TDGMultilevelHeaderCollectionItem;
    FOnChange: TNotifyEvent;
    function GetItem(Index: Integer): TDGMultilevelHeaderCollectionItem; reintroduce;
    procedure SetItem(Index: Integer; const Value: TDGMultilevelHeaderCollectionItem);

    function TraverseGetPathDepth(Header: TDGMultilevelHeaderCollection; PathName: String; Level: Integer; PathPrefix: String = ''): Integer;
    function Traverse(Header: TDGMultilevelHeaderCollection; Callback: TFunc<TDGMultilevelHeaderParams, Boolean>; Level: Integer = 1; PathPrefix: String = ''): Boolean; overload;
  protected
    procedure DoChange; override;
    procedure Update(Item: TCollectionItem); override;
  public
    constructor Create(AOwner: TComponent); reintroduce; overload;
    function Add: TDGMultilevelHeaderCollectionItem; reintroduce;
    function Insert(Index: integer): TDGMultilevelHeaderCollectionItem; reintroduce;
    property Items[Index: Integer]: TDGMultilevelHeaderCollectionItem read GetItem write SetItem;
    function GetPathName(Item: TDGMultilevelHeaderCollectionItem): String;
    function GetPathItem(PathName: String): TDGMultilevelHeaderCollectionItem;
    function GetPathDepth(PathName: String): Integer;
    function GetMaxDepth: Integer;
    property ParentItem: TDGMultilevelHeaderCollectionItem read FParentItem;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    function Traverse(Callback: TFunc<TDGMultilevelHeaderParams, Boolean>): Boolean; overload;
  end;
{$ENDREGION}
{$REGION 'TDGColumnDefsCollection'}
  TDGColumnDefsCollection = class;
  TDGColumnDefsCollectionItemBase = class(TDGCollectionItem)
  private
    FHeaderName: string;
    FFilter: Boolean;
    FCellRenderer: TJSValue;
    FCellEditor: TJSValue;
    FEditModeType: TDGCellEditorType;
    FEditable: Boolean;
    FEditable_Set: Boolean;
    FViewModeType: TDGCellRendererType;
    FValueFormatter: TDGColumnValueFormatter;
    FCheckboxSelection: Boolean;
    FOnChange: TNotifyEvent;
    FWidth: Integer;
    FFlex: Integer;
    FLockPinned: Boolean;
    FCellDataType: TDGCellDataType;
    FOnCustomRender: TDGCustomCellRender;
    FVisible: Boolean;
    FValueGetter: TDGColumnValueGetter;
    FSortable: Boolean;
    FSelectOptions: TDGSelectCellEditorCollection;
    FOnGetCellClass: TDGCellClassFunc;
    FOnGetCellStyle: TDGCellStyleFunc;
    FResizable: Boolean;
    FLockVisible: Boolean;
    FSuppressMovable: Boolean;
    FEnableCellChangeFlash: Boolean;
    FFloatingFilter: Boolean;
    FParentHeader: TDGMultilevelHeaderCollectionItem;
    FParentHeaderStr: String;
    FParent: TDGColumnDefsCollection;
    FFilter_Set: Boolean;
    FAutoHeight: Boolean;
    FAutoHeaderHeight: Boolean;
    FWrapText: Boolean;
    FWrapHeaderText: Boolean;
    procedure SetAutoHeaderHeight(const Value: Boolean);
    procedure SetAutoHeight(const Value: Boolean);
    procedure SetWrapHeaderText(const Value: Boolean);
    procedure SetWrapText(const Value: Boolean);

    property Editable_Set: Boolean read FEditable_Set write FEditable_Set;
    property Filter_Set: Boolean read FFilter_Set write FFilter_Set;
    procedure SetParentHeader(const Value: String);
    procedure SetField(const Value: string);


    procedure _SetCellRenderer(Props: TJSPropertySerializer; Value: TJSValue);
    procedure _SetCellEditor(Props: TJSPropertySerializer; Value: TJSValue);

    procedure SetHeaderName(const Value: string);
    procedure SetOnCustomRender(const Value: TDGCustomCellRender);
    procedure SetSelectOptions(const Value: TDGSelectCellEditorCollection);
    procedure SetCellDataType(const Value: TDGCellDataType);
    procedure SetFilter(const Value: Boolean);
    procedure SetEditModeType(const Value: TDGCellEditorType);
    procedure SetCheckboxSelection(const Value: Boolean);
    procedure SetEditable(const Value: Boolean);
    procedure SetLockPinned(const Value: Boolean);
    procedure SetSortable(const Value: Boolean);
    procedure SetValueFormatter(const Value: TDGColumnValueFormatter);
    procedure SetValueGetter(const Value: TDGColumnValueGetter);
    procedure SetViewModeType(const Value: TDGCellRendererType);
    procedure SetVisible(const Value: Boolean);
    procedure SetWidth(const Value: Integer);
    procedure SetFlex(const Value: Integer);
    procedure SetCellEditor(const Value: TJSValue);
    procedure SetCellRenderer(const Value: TJSValue);
    procedure SetResizable(const Value: Boolean);
    procedure SetSuppressMovable(const Value: Boolean);
    procedure SetLockVisible(const Value: Boolean);
    procedure SetEnableCellChangeFlash(const Value: Boolean);
    procedure SetOnGetCellStyle(const Value: TDGCellStyleFunc);
    procedure SetOnGetCellClass(const Value: TDGCellClassFunc);
    procedure SetFloatingFilter(const Value: Boolean);
    function GetParentHeader: String;

  protected
    FField: string;
    function GetDisplayName: string; override;

    procedure DoChange;
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    function GetAsJSObject: TJSObject;

    function GetNamePath: string; override;

    property CellRenderer: TJSValue read FCellRenderer write SetCellRenderer;
    property CellEditor: TJSValue read FCellEditor write SetCellEditor;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
    property Parent: TDGColumnDefsCollection read FParent write FParent;
  published
    property Field: string read FField write SetField;
    property CellDataType: TDGCellDataType read FCellDataType write SetCellDataType;
    property HeaderName: string read FHeaderName write SetHeaderName;
    property ParentHeader: string read GetParentHeader write SetParentHeader;
    property Filter: Boolean read FFilter write SetFilter;
    property SearchFilter: Boolean read FFloatingFilter write SetFloatingFilter default False;
    property EditModeType: TDGCellEditorType read FEditModeType write SetEditModeType default cetDefault;
    property Editable: Boolean read FEditable write SetEditable;
    property ViewModeType: TDGCellRendererType read FViewModeType write SetViewModeType default crtDefault;

    property ValueGetter: TDGColumnValueGetter read FValueGetter write SetValueGetter;
    property ValueFormatter: TDGColumnValueFormatter read FValueFormatter write SetValueFormatter;
    property CheckboxSelection: Boolean read FCheckboxSelection write SetCheckboxSelection;

    property Resizable: Boolean read FResizable write SetResizable default False;
    property Sortable: Boolean read FSortable write SetSortable default True;
    property Visible: Boolean read FVisible write SetVisible default True;
    property Width: Integer read FWidth write SetWidth default 0;
    property Flex: Integer read FFlex write SetFlex default 0;
    property WrapText: Boolean read FWrapText write SetWrapText default False;
    property AutoHeight: Boolean read FAutoHeight write SetAutoHeight default False;
    property WrapHeaderText: Boolean read FWrapHeaderText write SetWrapHeaderText default False;
    property AutoHeaderHeight: Boolean read FAutoHeaderHeight write SetAutoHeaderHeight default False;
    property LockPinned: Boolean read FLockPinned write SetLockPinned;
    property SelectOptions: TDGSelectCellEditorCollection read FSelectOptions write SetSelectOptions;
    property SuppressMovable: Boolean read FSuppressMovable write SetSuppressMovable default False;
    property LockVisible: Boolean read FLockVisible write SetLockVisible default True;
    property EnableCellChangeFlash: Boolean read FEnableCellChangeFlash write SetEnableCellChangeFlash default False;

    property OnCustomRender: TDGCustomCellRender read FOnCustomRender write SetOnCustomRender;
    property OnGetCellStyle: TDGCellStyleFunc read FOnGetCellStyle write SetOnGetCellStyle;
    property OnGetCellClass: TDGCellClassFunc read FOnGetCellClass write SetOnGetCellClass;
  end;
  TDGColumnDefsCollectionItem = class(TDGColumnDefsCollectionItemBase)

  end;
  TDGColumnDefsCollectionItemBaseInternal = class abstract (TDGColumnDefsCollectionItem)
  public
    property Editable_Set;
    property Filter_Set;
  end;
  TDGColumnDefsCollection = class(TDGCollection)
  private
    FOnChange: TNotifyEvent;
    function GetItem(Index: integer): TDGColumnDefsCollectionItem; reintroduce;
    procedure SetItem(Index: integer; const Value: TDGColumnDefsCollectionItem); reintroduce;
  protected
    procedure DoChange; override;
    procedure Update(Item: TCollectionItem); override;
  public
    constructor Create(AOwner: TComponent); reintroduce; overload;
    constructor Create(AOwner: TPersistent; ItemClass: TCollectionItemClass); overload;
    function Add: TDGColumnDefsCollectionItem; reintroduce;
    function Insert(Index: integer): TDGColumnDefsCollectionItem; reintroduce;
    property Items[Index: integer]: TDGColumnDefsCollectionItem read GetItem write SetItem; default;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;

    function FindColumnIndex(FieldName: String): Integer;
  end;
{$ENDREGION}
{$REGION 'TDGDefaultColDef'}
  TDGDefaultColDef = class(TDGPersistent)
  private
    FLockVisible: Boolean;
    FFloatingFilter: Boolean;
    FSuppressMovable: Boolean;
    FWidth: String;
    FLockPinned: Boolean;
    FResizable: Boolean;
    FSortable: Boolean;
    FFilter: Boolean;
    FEditable: Boolean;
    FEnabled: Boolean;
    procedure SetEditable(const Value: Boolean);
    procedure SetFilter(const Value: Boolean);
    procedure SetFloatingFilter(const Value: Boolean);
    procedure SetLockPinned(const Value: Boolean);
    procedure SetLockVisible(const Value: Boolean);
    procedure SetResizable(const Value: Boolean);
    procedure SetSortable(const Value: Boolean);
    procedure SetSuppressMovable(const Value: Boolean);
    procedure SetWidth(const Value: String);
    procedure SetEnabled(const Value: Boolean);
  public
    constructor Create;
    function GetAsJSObject: TJSObject;
  published
    property Enabled: Boolean read FEnabled write SetEnabled default False;
    property Filter: Boolean read FFilter write SetFilter default False;
    property SearchFilter: Boolean read FFloatingFilter write SetFloatingFilter default False;
    property Editable: Boolean read FEditable write SetEditable default False;
    property Resizable: Boolean read FResizable write SetResizable default False;
    property Sortable: Boolean read FSortable write SetSortable default True;
    property Width: String read FWidth write SetWidth;
    property LockPinned: Boolean read FLockPinned write SetLockPinned default False;
    property SuppressMovable: Boolean read FSuppressMovable write SetSuppressMovable default False;
    property LockVisible: Boolean read FLockVisible write SetLockVisible default False;

  end;
{$ENDREGION}
{$REGION 'TDGBanding'}
  TDGBanding = class(TDGPersistent)
  private
    FOddRowsColor: TColor;
    FEvenRowsColor: TColor;
    FEnabled: Boolean;
    procedure SetEvenRowsColor(const Value: TColor);
    procedure SetOddRowsColor(const Value: TColor);
    procedure SetEnabled(const Value: Boolean);
  public
    constructor Create;
  published
    property Enabled: Boolean read FEnabled write SetEnabled;
    property OddRowsColor: TColor read FOddRowsColor write SetOddRowsColor;
    property EvenRowsColor: TColor read FEvenRowsColor write SetEvenRowsColor;
  end;
{$ENDREGION}
{$REGION 'TDGTheming'}
  TDGTheming = class(TDGPersistent)
  private
    FEnabled: Boolean;
    FBuiltInTheme: TDGBuiltInThemes;
    FThemeMode: TDGBuiltInThemeMode;
    procedure SetBuiltInTheme(const Value: TDGBuiltInThemes);
    procedure SetEnabled(const Value: Boolean);
    procedure SetThemeMode(const Value: TDGBuiltInThemeMode);

  public
    constructor Create;
    function GetThemeClass(): string;
  published
    property Enabled: Boolean read FEnabled write SetEnabled default True;
    property BuiltInTheme: TDGBuiltInThemes read FBuiltInTheme write SetBuiltInTheme default agThemeAlpine;
    property ThemeMode: TDGBuiltInThemeMode read FThemeMode write SetThemeMode default agLightMode;
  end;
{$ENDREGION}


{$REGION 'Utils'}
  TDGUtils = class
  public
    class function TColorToHex(Value: TColor): String;
    class function AsType<ObjectType: class>(Value: TObject): ObjectType;
  end;
{$ENDREGION}

implementation

uses
  WEBLib.DataGrid;

{$REGION 'TDGColumnDefsCollection'}
{ TDGColumnDefsCollectionItem }

procedure TDGColumnDefsCollectionItemBase.Assign(Source: TPersistent);
var
  SourceItem: TDGColumnDefsCollectionItemBase;
begin

  SourceItem := Source as TDGColumnDefsCollectionItemBase;
  if SourceItem <> nil then
  begin
    FField := SourceItem.FField;
    FHeaderName := SourceItem.FHeaderName;
  end;
end;

constructor TDGColumnDefsCollectionItemBase.Create(ACollection: TCollection);
begin
  inherited;
  FVisible := True;
  FSortable := True;
  FResizable := False;
  FSuppressMovable := False;
  FLockVisible := True;
  FEnableCellChangeFlash := False;
  FSelectOptions := TDGSelectCellEditorCollection.Create(ACollection.Owner);

  if Assigned(ACollection) and
     (ACollection.InheritsFrom(TDGColumnDefsCollection)) then
  begin
    FParent := TDGColumnDefsCollection(ACollection);
  end;

  Editable_Set := False;
  Filter_Set := False;
end;

destructor TDGColumnDefsCollectionItemBase.Destroy;
begin
  if Assigned(FSelectOptions) then
    FreeAndNil(FSelectOptions);
  inherited;
end;

procedure TDGColumnDefsCollectionItemBase.DoChange;
var
  Owner: TPersistent;
begin
  if Assigned(FOnChange) then
  begin
    FOnChange(Self);
  end;

  Owner := GetOwner;
  if (Owner <> nil) and
     (Owner.InheritsFrom(TDGColumnDefsCollection)) then
  begin
    TDGColumnDefsCollection(Owner).DoChange;
  end;
end;

{$REGION 'Array Setters'}


procedure TDGColumnDefsCollectionItemBase.SetValueFormatter(
  const Value: TDGColumnValueFormatter);
begin
  FValueFormatter := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetValueGetter(
  const Value: TDGColumnValueGetter);
begin
  FValueGetter := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetViewModeType(
  const Value: TDGCellRendererType);
begin
  FViewModeType := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetVisible(const Value: Boolean);
begin
  FVisible := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetWidth(const Value: Integer);
begin
  if (FWidth <> Value) and (Value >= 0) then
  begin
    if Value > 0 then
      FFlex := 0; // Flex and Width can not be used in the same column
    FWidth := Value;
    DoChange;
  end;
end;

procedure TDGColumnDefsCollectionItemBase.SetWrapHeaderText(
  const Value: Boolean);
begin
  FWrapHeaderText := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetWrapText(const Value: Boolean);
begin
  FWrapText := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase._SetCellRenderer(Props: TJSPropertySerializer; Value: TJSValue);
begin
  Props.Add('cellRenderer', Value, nil);
end;

procedure TDGColumnDefsCollectionItemBase.SetCheckboxSelection(
  const Value: Boolean);
begin
  FCheckboxSelection := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetEditable(const Value: Boolean);
begin
  FEditable := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetEditModeType(
  const Value: TDGCellEditorType);
begin
  FEditModeType := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetEnableCellChangeFlash(
  const Value: Boolean);
begin
  FEnableCellChangeFlash := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetAutoHeaderHeight(
  const Value: Boolean);
begin
  FAutoHeaderHeight := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetAutoHeight(const Value: Boolean);
begin
  FAutoHeight := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetCellDataType(
  const Value: TDGCellDataType);
begin
  FCellDataType := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetCellEditor(const Value: TJSValue);
begin
  FCellEditor := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetCellRenderer(const Value: TJSValue);
begin
  FCellRenderer := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase._SetCellEditor(Props: TJSPropertySerializer; Value: TJSValue);
begin
  Props.Add('cellEditor', Value, nil);
end;
{$ENDREGION}

function TDGColumnDefsCollectionItemBase.GetAsJSObject: TJSObject;
var
  Props: TJSPropertySerializer;
  callback: TJSFunction;

begin
  callback := nil;
  Props := TJSPropertySerializer.Create;
  try
    if Length(FField) > 0 then
      Props.Add('field', FField);
    if Length(FHeaderName) > 0 then
      Props.Add('headerName', FHeaderName);
    if FFilter or FFilter_Set then
      Props.Add('filter', FFilter, not FFilter);
    if FFloatingFilter then
      Props.Add('floatingFilter', FFloatingFilter);
    if FWidth > 0 then
      Props.Add('width', FWidth);
    if FLockPinned then
      Props.Add('lockPinned', FLockPinned);
    Props.Add('hide', not FVisible, FVisible);
    Props.Add('sortable', FSortable, True);
    Props.Add('resizable', FResizable, False);
    Props.Add('suppressMovable', FSuppressMovable, False);
    Props.Add('lockVisible', FLockVisible, False);
    Props.Add('enableCellChangeFlash', FEnableCellChangeFlash, False);

    Props.AddType<TDGCellDataType>('cellDataType', FCellDataType, function(Value: TDGCellDataType): TJSValue
    begin
      Result := nil;
      case Value of
        cdtText: Result := 'text';
        cdtNumber: Result := 'number';
        cdtBoolean: Result := 'boolean';
        cdtDate: Result := 'date';
        cdtDateString: Result := 'dateString';

        cdtObject: Result := 'object';
      end;
    end);


    if CellRenderer <> nil then
    begin
      _SetCellRenderer(Props, CellRenderer);
    end
    else
    begin
      case FViewModeType of
        crtText: _SetCellRenderer(Props, TEmbeddedJSCellComponents.TcrTextRendererComponent);
        crtImage: _SetCellRenderer(Props, TEmbeddedJSCellComponents.TcrImageRendererComponent);
        crtURL: _SetCellRenderer(Props, TEmbeddedJSCellComponents.TcrURLRendererComponent);
        crtEmail:  _SetCellRenderer(Props, TEmbeddedJSCellComponents.TcrURLRendererComponent);
        crtTel:  _SetCellRenderer(Props, TEmbeddedJSCellComponents.TcrTelRendererComponent);
        crtCustom:
          begin
            if Assigned(FOnCustomRender) then
            begin
              _SetCellRenderer(Props, TJSValue(Pointer({$IFNDEF PAS2JS}@{$ENDIF}FOnCustomRender)));

            end;
          end;

        crtCheckbox:  _SetCellRenderer(Props, 'agCheckboxCellRenderer');
      end;
    end;

    if CellEditor <> nil then
    begin
      _SetCellEditor(Props, CellEditor);
    end
    else
    begin
      case FEditModeType of
        cetText: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceTextEditorComponent);
        cetNumber: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceNumberEditorComponent);
        cetDate: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceDateEditorComponent);
        cetTime: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceTimeEditorComponent);
        cetRange: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceRangeEditorComponent);
        cetColor: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceColorEditorComponent);
        cetWeek: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceWeekEditorComponent);
        cetMonth: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceMonthEditorComponent);
        cetURL: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceURLEditorComponent);
        cetEmail: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceEmailEditorComponent);
        cetTel: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceTelEditorComponent);
        cetNone: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceNoneEditorComponent);
        cetCustom: ;
        cetCheckbox: _SetCellEditor(Props, 'agCheckboxCellEditor');

        cetCombobox:
          begin
            _SetCellEditor(Props, 'agSelectCellEditor');

            if Assigned(FSelectOptions) then
            begin
              Props.AddType<TDGSelectCellEditorCollection>('cellEditorParams', FSelectOptions,
              function (Items: TDGSelectCellEditorCollection) : TJSValue
              var
                I: Integer;
                Arr: TJSArray;
              begin
                Result := nil;
                if (Items <> nil) and (Items.Count > 0) then
                begin
                  Arr := TJSArray._of;
                  for I := 0 to Items.Count - 1 do
                  begin
                    Arr.push(Items[I].Text);
                  end;
                  Result := new(['values', Arr]);
                end;
              end);
            end;
          end;
        cetDateTime: _SetCellEditor(Props, TEmbeddedJSCellComponents.TceDateEditorComponent);
      end;
    end;

    if FEditable or FEditable_Set then
      Props.Add('editable', FEditable, not FEditable);


    if Assigned(FValueFormatter) then
    begin
{$IFDEF PAS2JS}asm
      var formatter = this.FValueFormatter;
      callback = (function(params) {
        let value = params.value;
        if (typeof(value) == "undefined") {
          value = null;
        } else if (value == null) {
          value = null;
        } else if (typeof(value) != "string") {
          value = value.toString();
        }                                                  9
        return(formatter(value));
      });
end;{$ENDIF}
      Props.Add('valueFormatter', callback, nil);
    end;
    if Assigned(FValueGetter) then
      Props.Add('valueGetter', {$IFNDEF PAS2JS}@{$ENDIF}FValueGetter, 'FValueGetter');

    if FCheckboxSelection then
      Props.Add('checkboxSelection', FCheckboxSelection);

    if FEnableCellChangeFlash then
      Props.Add('enableCellChangeFlash', FEnableCellChangeFlash);

    Props.Add('cellStyle', {$IFNDEF PAS2JS}@{$ENDIF}FOnGetCellStyle, nil);
    Props.Add('cellClass', {$IFNDEF PAS2JS}@{$ENDIF}FOnGetCellClass, nil);


    if FFlex > 0 then
      Props.Add('flex', FFlex);
    if FWrapText then
      Props.Add('wrapText', FWrapText);
    if FAutoHeight then
      Props.Add('autoHeight', FAutoHeight);
    if FWrapHeaderText then
      Props.Add('wrapHeaderText', FWrapHeaderText);
    if FAutoHeaderHeight then
      Props.Add('autoHeaderHeight', FAutoHeaderHeight);

    Result := Props.AsJsObject;
  finally
    Props.Free;
  end;
end;


function TDGColumnDefsCollectionItemBase.GetDisplayName: string;
begin
  if FField <> '' then
  begin
    Result := FField;
    if FHeaderName <> '' then
    begin
      Result := Result + ' (' + FHeaderName + ')';
    end;
  end
  else
  begin
    Result := 'Requires Field Name!';
  end;
end;

function TDGColumnDefsCollectionItemBase.GetNamePath: string;
begin
  if (Collection <> nil) and
     (Collection.Owner <> nil) and
     (Length(FField) > 0) then
    Result := Format('%s.Column_%s',[Collection.Owner.GetNamePath, FField])
  else
    Result := inherited GetNamePath;
end;

procedure TDGColumnDefsCollectionItemBase.SetField(const Value: string);
begin
  // Replace all invalid characters

  FField := TRegEx.Replace(Value, '[''"]', '');
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetFilter(const Value: Boolean);
begin
  FFilter := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetFlex(const Value: Integer);
begin
  if (FFlex <> Value) and (Value >= 0) then
  begin
    if Value > 0 then
      FWidth := 0; // Flex and Width can not be used in the same column
    FFlex := Value;
    DoChange;
  end;
end;

procedure TDGColumnDefsCollectionItemBase.SetFloatingFilter(const Value: Boolean);
begin
  FFloatingFilter := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetHeaderName(const Value: string);
begin
  FHeaderName := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetLockPinned(const Value: Boolean);
begin
  FLockPinned := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetLockVisible(const Value: Boolean);
begin
  FLockVisible := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetOnCustomRender(
  const Value: TDGCustomCellRender);
begin
  FOnCustomRender := Value;
  if Assigned(FOnCustomRender) then
    ViewModeType := crtCustom;
  DoChange;
end;

function TDGColumnDefsCollectionItemBase.GetParentHeader: String;
var
  Owner: TPersistent;
  Grid: TDataGrid;
begin
  Result := '';
  Owner := GetOwner;
  if Assigned(Owner) and
     (Owner.InheritsFrom(TDGColumnDefsCollection)) then
  begin
    Owner := TDGColumnDefsCollection(Owner).Owner;
    if Assigned(Owner) and
       (Owner.InheritsFrom(TDataGrid)) then
    begin
      Grid := TDataGrid(Owner);
      if Grid.IsLoading then
        Result := FParentHeaderStr
      else if FParentHeaderStr <> '' then
      begin
        FParentHeader := Grid.MultilevelHeaders.GetPathItem(FParentHeaderStr);
        FParentHeaderStr := '';
        if Assigned(FParentHeader) then
        begin
          Result := FParentHeader.GetPathName;
        end;
      end
      else if Assigned(FParentHeader) then
      begin
        Result := FParentHeader.GetPathName;
      end;
    end;
  end;
end;

procedure TDGColumnDefsCollectionItemBase.SetParentHeader(
  const Value: String);
var
  Owner: TPersistent;
  NewValue: TDGMultilevelHeaderCollectionItem;
  Grid: TDataGrid;
begin
  Owner := GetOwner;
  if Assigned(Owner) and
     (Owner.InheritsFrom(TDGColumnDefsCollection)) then
  begin
    Owner := TDGColumnDefsCollection(Owner).Owner;
    if Assigned(Owner) and
       (Owner.InheritsFrom(TDataGrid)) then
    begin
      Grid := TDataGrid(Owner);
      if Grid.IsLoading then
      begin
        FParentHeaderStr := Value;
        FParentHeader := nil;
      end
      else if Assigned(Grid.MultilevelHeaders) then
      begin
        NewValue := Grid.MultilevelHeaders.GetPathItem(Value);
        if FParentHeader <> NewValue then
        begin
          FParentHeader := NewValue;
          DoChange;
        end;
      end;
    end;
  end;
end;

procedure TDGColumnDefsCollectionItemBase.SetOnGetCellClass(
  const Value: TDGCellClassFunc);
begin
  FOnGetCellClass := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetOnGetCellStyle(
  const Value: TDGCellStyleFunc);
begin
  FOnGetCellStyle := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetSelectOptions(
  const Value: TDGSelectCellEditorCollection);
begin
  if Assigned(FSelectOptions) then
  begin
    FSelectOptions.Assign(Value);
    DoChange;
  end;
end;

procedure TDGColumnDefsCollectionItemBase.SetResizable(const Value: Boolean);
begin
  FResizable := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetSortable(const Value: Boolean);
begin
  FSortable := Value;
  DoChange;
end;

procedure TDGColumnDefsCollectionItemBase.SetSuppressMovable(const Value: Boolean);
begin
  FSuppressMovable := Value;
  DoChange;
end;

{ TDGColumnDefsCollection }

function TDGColumnDefsCollection.Add: TDGColumnDefsCollectionItem;
begin
  Result := TDGColumnDefsCollectionItem(inherited Add);
end;

constructor TDGColumnDefsCollection.Create(AOwner: TPersistent;
  ItemClass: TCollectionItemClass);
begin
  inherited Create(AOwner, ItemClass);
end;

constructor TDGColumnDefsCollection.Create(AOwner: TComponent);
begin
  inherited Create(AOwner, TDGColumnDefsCollectionItem);
end;


function TDGColumnDefsCollection.GetItem(
  Index: integer): TDGColumnDefsCollectionItem;
begin
  Result := TDGColumnDefsCollectionItem(inherited Items[Index]);
end;

function TDGColumnDefsCollection.Insert(
  Index: integer): TDGColumnDefsCollectionItem;
begin
  Result := TDGColumnDefsCollectionItem(inherited Insert(Index));
end;

procedure TDGColumnDefsCollection.SetItem(Index: integer;
  const Value: TDGColumnDefsCollectionItem);
begin
  inherited Items[Index] := Value;
end;

procedure TDGColumnDefsCollection.DoChange;
begin
  inherited DoChange;
  if Assigned(FOnChange) then
  begin
    FOnChange(Self);
  end;
end;

function TDGColumnDefsCollection.FindColumnIndex(FieldName: String): Integer;
var
  I: Integer;
  CurrentItem: TDGColumnDefsCollectionItem;
begin
  Result := -1;
  for I := 0 to Count - 1 do
  begin
    CurrentItem := Items[I];
    if CurrentItem.FField = FieldName then
      Result := I;
  end;
end;

procedure TDGColumnDefsCollection.Update(Item: TCollectionItem);
begin
  inherited;

  if Assigned(TComponent(Owner)) and
     (not (csLoading in TComponent(Owner).ComponentState)) then
    DoChange;
end;

{$ENDREGION}

{$REGION 'TDGUtils'}
{ TDGUtils }
  
class function TDGUtils.AsType<ObjectType>(Value: TObject): ObjectType;
begin
  Result := default(ObjectType);
  if Assigned(Value) then
  begin
    if Value is ObjectType then
    begin
      Result := ObjectType(Value);
    end;
  end;
end;

class function TDGUtils.TColorToHex(Value: TColor): String;
var
  N: Longint;
  R,G,B: Longint;
begin
  N := ColorToRGB(Value);
  R := N and $000000FF;
  G := (N and $0000FF00) shr 8;
  B := (N and $00FF0000) shr 16;
  Result := IntToHex(R,2)+IntToHex(G,2)+IntToHex(B,2);
end;
  
{$ENDREGION}

{$REGION 'TDGBanding'}
{ TDGBanding }
  
constructor TDGBanding.Create;
begin
  inherited Create;
  FEnabled := False;
  FOddRowsColor := clWhite;
  FEvenRowsColor := clWhite;
end;

procedure TDGBanding.SetEnabled(const Value: Boolean);
begin
  FEnabled := Value;
  DoChange;
end;

procedure TDGBanding.SetEvenRowsColor(const Value: TColor);
begin
  FEvenRowsColor := Value;
  DoChange;
end;
  
procedure TDGBanding.SetOddRowsColor(const Value: TColor);
begin
  FOddRowsColor := Value;
  DoChange;
end;
  
{$ENDREGION}


{$REGION 'TDGCollection'}
{ TDGCollection }

procedure TDGCollection.ApplyChanges;
begin
  FInChangeTransaction := False;
  DoChange;
end;

procedure TDGCollection.RegisterCallback(Callback: TDataGridChangedEvent);
begin
  FCallback := Callback;
end;

procedure TDGCollection.BeginChanges;
begin
  FInChangeTransaction := True;
end;

procedure TDGCollection.DoChange;
begin
  if (not FInChangeTransaction) and
     Assigned(FCallback) then
    FCallback(Self);
end;


{$IFNDEF FAKEINTERFACE}
function TDGCollection.QueryInterface(const IID: TGUID; out Obj): HResult;
begin
  if GetInterface(IID, Obj) then
    Result := 0
  else
    Result := E_NOINTERFACE;
end;

function TDGCollection._AddRef: Integer;
begin
  Result := -1;
end;

function TDGCollection._Release: Integer;
begin
  Result := -1;
end;
{$ENDIF}

{$ENDREGION}

{$REGION 'TDGPersistent'}
{ TDGPersistent }

procedure TDGPersistent.ApplyChanges;
begin
  FInChangeTransaction := False;
  DoChange;
end;

procedure TDGPersistent.BeginChanges;
begin
  FInChangeTransaction := True;
end;

procedure TDGPersistent.DoChange;
begin
  if (not FInChangeTransaction) and
     Assigned(FCallback) then
    FCallback(Self);
end;

procedure TDGPersistent.RegisterCallback(Callback: TDataGridChangedEvent);
begin
  FCallback := Callback;
end;

{$IFNDEF FAKEINTERFACE}
function TDGPersistent.QueryInterface(const IID: TGUID; out Obj): HResult;
begin
  if GetInterface(IID, Obj) then
    Result := 0
  else
    Result := E_NOINTERFACE;
end;

function TDGPersistent._AddRef: Integer;
begin
  Result := -1;
end;

function TDGPersistent._Release: Integer;
begin
  Result := -1;
end;
{$ENDIF}

{$ENDREGION}



{$REGION 'TGSTheming'}
{ TGSTheming }

constructor TDGTheming.Create;
begin
  inherited Create;
  FEnabled := true;
  FBuiltInTheme := agThemeAlpine;
  FThemeMode := agLightMode;

end;

function TDGTheming.GetThemeClass: string;
begin
  Result := '';
  if FEnabled then
  begin
    case FBuiltInTheme of
      agThemeAlpine: Result := 'ag-theme-alpine';
      agThemeBalham: Result := 'ag-theme-balham';
      agThemeMaterial: Result := 'ag-theme-material';
      agThemeQuartz: Result := 'ag-theme-quartz';
      agThemeCustom: Result := 'ag-theme-custom';
    end;
    case FThemeMode of
      agDarkMode: Result := Result + '-dark';
      agAutoDarkMode: Result := Result + '-auto-dark';
    end;
  end;
end;

procedure TDGTheming.SetBuiltInTheme(const Value: TDGBuiltInThemes);
begin
  FBuiltInTheme := Value;
  DoChange;
end;

procedure TDGTheming.SetEnabled(const Value: Boolean);
begin
  FEnabled := Value;
  DoChange;
end;

procedure TDGTheming.SetThemeMode(const Value: TDGBuiltInThemeMode);
begin
  FThemeMode := Value;
  DoChange;
end;


{$ENDREGION}

{$REGION 'Cell Editor Params'}
{ TDGSelectCellEditorCollectionItem }

procedure TDGSelectCellEditorCollectionItem.Assign(Source: TPersistent);
var
  SourceItem: TDGSelectCellEditorCollectionItem;
begin
  SourceItem := Source as TDGSelectCellEditorCollectionItem;
  if SourceItem <> nil then
  begin
    FText := SourceItem.FText;
  end;
end;

function TDGSelectCellEditorCollectionItem.GetDisplayName: string;
begin
  Result := '(Empty String)';
  if Length(FText) > 0 then
  begin
    Result := FText;
  end;
end;

{ TDGSelectCellEditorCollection }

function TDGSelectCellEditorCollection.Add: TDGSelectCellEditorCollectionItem;
begin
  Result := TDGSelectCellEditorCollectionItem(inherited Add);
end;

constructor TDGSelectCellEditorCollection.Create(AOwner: TPersistent;
  ItemClass: TCollectionItemClass);
begin
  inherited Create(AOwner, ItemClass);
end;

constructor TDGSelectCellEditorCollection.Create(AOwner: TPersistent);
begin
  inherited Create(AOwner, TDGSelectCellEditorCollectionItem);
end;

procedure TDGSelectCellEditorCollection.DoChange;
begin
  if Assigned(OnChange) then
    OnChange(Self);
end;

function TDGSelectCellEditorCollection.GetItem(
  Index: integer): TDGSelectCellEditorCollectionItem;
begin
  Result := TDGSelectCellEditorCollectionItem(inherited Items[Index]);
end;

function TDGSelectCellEditorCollection.Insert(
  Index: integer): TDGSelectCellEditorCollectionItem;
begin
  Result := TDGSelectCellEditorCollectionItem(inherited Insert(Index));
end;

procedure TDGSelectCellEditorCollection.SetItem(Index: integer;
  const Value: TDGSelectCellEditorCollectionItem);
begin
  inherited Items[Index] := Value;
end;

procedure TDGSelectCellEditorCollection.Update(Item: TCollectionItem);
begin
  inherited;
  if Assigned(TComponent(Owner)) and
     (not (csLoading in TComponent(Owner).ComponentState)) then
    DoChange;
end;
{$ENDREGION}

{$REGION 'TDGMultilevelHeaderCollection'}
{ TDGMultilevelHeaderCollectionItem }

constructor TDGMultilevelHeaderCollectionItem.Create(ACollection: TCollection);
var
  Owner: TPersistent;
begin
  inherited;
  Owner := GetOwner;
  if Assigned(Owner) and
     (Owner.InheritsFrom(TDGMultilevelHeaderCollection)) then
  begin
    Owner := TDGMultilevelHeaderCollection(Owner).GetOwner;
    if Assigned(Owner) and
       (Owner.InheritsFrom(TComponent)) then
    begin
      FHeaders := TDGMultilevelHeaderCollection.Create(TComponent(Owner));
      FHeaders.FParentItem := Self;
    end;
  end;

  if Assigned(ACollection) and
     (ACollection.InheritsFrom(TDGMultilevelHeaderCollection)) then
  begin
    FParent := TDGMultilevelHeaderCollection(ACollection);
  end;
end;

destructor TDGMultilevelHeaderCollectionItem.Destroy;
begin
  if Assigned(FParent) then
    FParent := nil;
  if Assigned(FHeaders) then
  begin
    FreeAndNil(FHeaders);
  end;
  inherited;
end;

procedure TDGMultilevelHeaderCollectionItem.DoChange;
var
  Owner: TPersistent;
begin
  if Assigned(FOnChange) then
  begin
    FOnChange(Self);
  end;

  Owner := GetOwner;
  if (Owner <> nil) and
     (Owner.InheritsFrom(TDGMultilevelHeaderCollection)) then
  begin
    TDGMultilevelHeaderCollection(Owner).DoChange;
  end;
end;

procedure TDGMultilevelHeaderCollectionItem.SetName(const Value: String);
begin
  FName := Value;
  DoChange;
end;

procedure TDGMultilevelHeaderCollectionItem.SetHeaders(
  const Value: TDGMultilevelHeaderCollection);
begin
  if Assigned(FHeaders) then
  begin
    FHeaders.Assign(Value);
  end;
end;

function TDGMultilevelHeaderCollectionItem.GetDisplayName: string;
begin
  if FName <> '' then
  begin
    Result := FName;
  end
  else
  begin
    Result := 'Requires a unique name!';
  end;
end;

function TDGMultilevelHeaderCollectionItem.GetPathName: String;
var
  Owner: TPersistent;
  Grid: TDataGrid;
begin
  Result := '';
  Owner := GetOwner;
  if Assigned(Owner) and
     (Owner.InheritsFrom(TDGMultilevelHeaderCollection)) then
  begin
    Owner := TDGMultilevelHeaderCollection(Owner).Owner;
    if Assigned(Owner) and
       (Owner.InheritsFrom(TDataGrid)) then
    begin
      Grid := TDataGrid(Owner);
      if Assigned(Grid.MultilevelHeaders) then
        Result := Grid.MultilevelHeaders.GetPathName(Self);
    end;
  end;
end;


{ TDGMultilevelHeaderCollection }

constructor TDGMultilevelHeaderCollection.Create(AOwner: TComponent);
begin
  inherited Create(AOwner, TDGMultilevelHeaderCollectionItem);
end;

function TDGMultilevelHeaderCollection.GetItem(Index: Integer): TDGMultilevelHeaderCollectionItem;
var
  ColItem: TCollectionItem;
begin
  Result := nil;
  ColItem := inherited GetItem(Index);
  if Assigned(ColItem) and
     (ColItem.InheritsFrom(TDGMultilevelHeaderCollectionItem)) then
    Result := TDGMultilevelHeaderCollectionItem(ColItem);
end;

procedure TDGMultilevelHeaderCollection.SetItem(Index: Integer;
  const Value: TDGMultilevelHeaderCollectionItem);
begin
  inherited SetItem(Index, Value);
end;

function TDGMultilevelHeaderCollection.Add: TDGMultilevelHeaderCollectionItem;
begin
  Result := TDGMultilevelHeaderCollectionItem(inherited Add);
end;

function TDGMultilevelHeaderCollection.Insert(
  Index: integer): TDGMultilevelHeaderCollectionItem;
begin
  Result := TDGMultilevelHeaderCollectionItem(inherited Insert(Index));
end;

function TDGMultilevelHeaderCollection.GetMaxDepth: Integer;
var
  I, Depth: Integer;
begin
  Result := 0;
  for I := 0 to Count - 1 do
  begin
    Depth := Items[I].FHeaders.GetMaxDepth + 1;
    if Result < Depth then
    begin
      Result := Depth;
    end;
  end;
end;

function TDGMultilevelHeaderCollection.GetPathName(Item: TDGMultilevelHeaderCollectionItem): String;
var
  PathName: String;
begin
//  Result := TraverseGetPathName(Self, Item);
  PathName := '';
  Traverse(Self, function (Params: TDGMultilevelHeaderParams): Boolean
    begin
      Result := False;
      if Params.Item = Item then
      begin
        PathName := Params.PathName;
        Result := True;
      end;
    end);
  Result := PathName;
end;

function TDGMultilevelHeaderCollection.GetPathDepth(PathName: String): Integer;
begin
  Result := TraverseGetPathDepth(Self, PathName, 1);
end;

function TDGMultilevelHeaderCollection.GetPathItem(PathName: String): TDGMultilevelHeaderCollectionItem;
var
  PathItem: TDGMultilevelHeaderCollectionItem;
begin
//  Result := TraverseGetPathItem(Self, PathName);
  PathItem := nil;
  Traverse(function(Params: TDGMultilevelHeaderParams): Boolean
    begin
      Result := False;
      if Params.PathName = PathName then
      begin
        PathItem := Params.Item;
        Result := True;
      end;
    end);
  Result := PathItem;
end;


function TDGMultilevelHeaderCollection.Traverse(Header: TDGMultilevelHeaderCollection; Callback: TFunc<TDGMultilevelHeaderParams, Boolean>; Level: Integer = 1; PathPrefix: String = ''): Boolean;
var
  Param: TDGMultilevelHeaderParams;
  I: Integer;
  NextPathPrefix: String;
begin
  Result := False;
  for I := 0 to Header.Count - 1 do
  begin
    Param.Item := Header.Items[I];
    Param.PathName := PathPrefix + Param.Item.FName;
    Param.Level := Level;

    if Callback(Param) then
      Exit;

    if Assigned(Param.Item.Headers) then
    begin
      NextPathPrefix := Param.PathName + ' | ';
      Result := Traverse(Param.Item.Headers, Callback, Level + 1, NextPathPrefix);
      if Result then
        Exit;
    end;
  end;
end;

function TDGMultilevelHeaderCollection.Traverse(Callback: TFunc<TDGMultilevelHeaderParams, Boolean>): Boolean;
begin
  Result := Traverse(Self, Callback);
end;



function TDGMultilevelHeaderCollection.TraverseGetPathDepth(
  Header: TDGMultilevelHeaderCollection; PathName: String; Level: Integer; PathPrefix: String): Integer;
var
  I: Integer;
  CurrentItem: TDGMultilevelHeaderCollectionItem;
  CurrentPath, NextPathPrefix: String;
begin
  Result := 0;
  for I := 0 to Header.Count - 1 do
  begin
    CurrentItem := Header.Items[I];
    CurrentPath := PathPrefix + CurrentItem.FName;

    if CurrentPath = PathName then
    begin
      Result := Level;
      Exit;
    end;

    if Assigned(CurrentItem.Headers) then
    begin
      NextPathPrefix := CurrentPath + ' | ';
      Result := TraverseGetPathDepth(CurrentItem.Headers, PathName, Level + 1, NextPathPrefix);
      if Result > 0 then
        Exit;
    end;
  end;
end;


procedure TDGMultilevelHeaderCollection.DoChange;
begin
  inherited DoChange;
  if Assigned(FOnChange) then
  begin
    FOnChange(Self);
  end;
end;

procedure TDGMultilevelHeaderCollection.Update(Item: TCollectionItem);
begin
  inherited;
  if Assigned(TComponent(Owner)) and
     (not (csLoading in TComponent(Owner).ComponentState)) then
    DoChange;
end;
{$ENDREGION}



{$REGION 'TDGDefaultColDef'}
{ TDGDefaultColDef }

constructor TDGDefaultColDef.Create;
begin
  inherited Create;
  FLockVisible := False;
  FFloatingFilter := False;
  FSuppressMovable := False;
  FWidth := '';
  FLockPinned := False;
  FResizable := False;
  FSortable := False;
  FFilter := False;
  FEditable := False;
  FEnabled := False;
end;

procedure TDGDefaultColDef.SetEditable(const Value: Boolean);
begin
  FEditable := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetEnabled(const Value: Boolean);
begin
  FEnabled := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetFilter(const Value: Boolean);
begin
  FFilter := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetFloatingFilter(const Value: Boolean);
begin
  FFloatingFilter := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetLockPinned(const Value: Boolean);
begin
  FLockPinned := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetLockVisible(const Value: Boolean);
begin
  FLockVisible := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetResizable(const Value: Boolean);
begin
  FResizable := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetSortable(const Value: Boolean);
begin
  FSortable := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetSuppressMovable(const Value: Boolean);
begin
  FSuppressMovable := Value;
  DoChange;
end;

procedure TDGDefaultColDef.SetWidth(const Value: String);
begin
  FWidth := Value;
  DoChange;
end;

function TDGDefaultColDef.GetAsJSObject: TJSObject;
var
  Props: TJSPropertySerializer;

begin

  Props := TJSPropertySerializer.Create;
  try
    if FFilter then
      Props.Add('filter', FFilter);
    if FFloatingFilter then
      Props.Add('floatingFilter', FFloatingFilter);
    if FWidth <> '' then
      Props.Add('width', StrToInt(FWidth));
    if FLockPinned then
      Props.Add('lockPinned', FLockPinned);

    Props.Add('sortable', FSortable, False);
    Props.Add('resizable', FResizable, False);
    Props.Add('suppressMovable', FSuppressMovable, False);
    Props.Add('lockVisible', FLockVisible, False);



    if FEditable then
      Props.Add('editable', FEditable);

    Result := Props.AsJsObject;
  finally
    Props.Free;
  end;
end;

{$ENDREGION}

end.
